import { task } from 'mobx-task';
import { boundMethod } from 'autobind-decorator';
import { composeDecorators } from '../../../helpers';

export const apiCall = composeDecorators(task.resolved, boundMethod);

export const apiFetch = composeDecorators(task, boundMethod);
